<template>
  <div class="grid_table_holder">
    <table class="table_basic">
      <tbody>
        <tr>
          <th v-t="'CELL_BID_ID'" scope="row" />
          <td>
            <div class="overflow-ellipsis">
              <TruncatedTextCopy
                :copy-text="bidRecord.bidId"
              >
                {{ bidRecord.bidId }}
              </TruncatedTextCopy>
            </div>
          </td>
        </tr>
        <tr>
          <th v-t="'CELL_BID_TIMESTAMP'" scope="row" />
          <td>
            <div class="overflow-ellipsis">
              <TruncatedTextCopy
                :copy-text="getTimestamp(bidRecord.bidDt)"
              >
                {{ getTimestamp(bidRecord.bidDt) }}
              </TruncatedTextCopy>
            </div>
          </td>
        </tr>
        <tr v-for="(row, index) in parsedData" :key="index">
          <th scope="row" valign="top">{{ row.name | camelCaseFormat }}</th>
          <td>
            <div class="overflow-ellipsis">
              <TruncatedTextCopy
                :copy-text="row.value"
              >
                {{ row.value }}
              </TruncatedTextCopy>
              <div
                v-if="row.name === 'reasonForReject'"
                class="basic-link__wrapper"
              >
                <a
                  v-t="'LEARN_MORE'"
                  href="https://support.ringba.com/en-us/article/rtb-error-codes-63832r/?bust=1672863848404"
                  class="basic-link text-underline"
                  target="_blank"
                />
                <i class="fa fa-external-link m-l-5 display-none" aria-hidden="true" />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import messages from '../../../locales';
import sharedMessages from '@/core/locales';

import TruncatedTextCopy from '@/angularBridgeCode/components/TruncatedTextCopy';


const excludeDataKeys = {
  trace: true,
  events: true,
  'message-tags': true,
  bidDt: true,
  bidId: true,
  winningBidCallAccepted: true,
  winningBid: true,
  isZeroBid: true
};

export default {
  name: 'RtbData',
  components: {
    TruncatedTextCopy
  },
  props: {
    bidRecord: {
      type: Object,
      default: () => {
        return {};
      }
    },
    timeZoneId: {
      type: String,
      default() {
        return moment.tz.guess();
      }
    },
  },
  data() {
    return {
      parsedData: []
    }
  },
  watch: {
    timeZoneId: {
      handler() {
        this.parsedData = this.parseData(this.bidRecord);
      },
      immediate: true
    }
  },
  mounted() {
    this.parsedData = this.parseData(this.bidRecord);
  },
  methods: {
    getTimestamp(dt) {
      return moment.tz(dt, this.timeZoneId).format('MMM DD YYYY, hh:mm:ss A');
    },
    parseData(data) {
      const parsedData = [];
      for (const key in data) {
        if (!excludeDataKeys[key] && data[key] !== '') {
          const dataValue = key.endsWith('Dt') ? this.getTimestamp(data[key]) : data[key];
          parsedData.push({
            name: key,
            value: dataValue
          });
        }
      }
      return parsedData;
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>